<template>
  <div class="NevadaNotice">
    <h2 class="NevadaNotice_Heading">PRIVACY NOTICE FOR NEVADA RESIDENTS</h2>

    <p>
      Nevada residents may have the right to request opt-out of the sale of
      Personal Information that we may collect through our websites or online
      applications. Grove Collaborative does not use your Personal Information
      in a way that constitutes a “sale” under the NPA (sell your personal
      information in exchange for monetary compensation). If you are a Nevada
      resident and wish to submit a request, contact
      <SkyLink to="mailto:support@grove.co" inline tag="a">
        support@grove.co</SkyLink
      >.
    </p>
  </div>
</template>

<style lang="scss">
.NevadaNotice {
  display: grid;
  row-gap: var(--spacing-3x);

  &_Heading {
    @include type-brand-heading('2');
    margin-top: var(--spacing-8x);
    text-align: center;
  }
}
</style>
